import {Avatar, Button, DatePicker, Input, InputNumber, Modal, Space} from 'antd'
import {course_getCourseClasses_Api} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {Formik} from 'formik'
import getTitle from 'helpers/getTitle'
import {getDateString, parseDayjs} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {IoCalendarOutline} from 'react-icons/io5'
import {RiListCheck2, RiSignalTowerFill, RiUserSharedLine} from 'react-icons/ri'
import {useLocation} from 'react-use'
import {compose, mapProps, pure, withProps} from 'recompose'
import {FetchClassById} from 'views/AppLocals/Course/components/FetchEntity'
import {NullAsDefault, pagerControls, renderIf, renderSelf, shallowDiff,} from 'views/Shared'
import {bindingSearch} from 'views/Shared/components/PagerControls'
import {renderCourseClass} from 'views/Workspace/Course/functions/renderCourseClass'
import {ClassActionTypes} from '..'
import {gConfigs} from '../../configs'
import {appClassNames} from '../../custom/appClassNames'
import EntityList from '../../EntityList'
import {showDeleteConfirmDialog} from '../../factory/createConfirmDialog'
import createContextMenu from '../../factory/createContextMenu'
import {createControlledFormField} from '../../factory/createFormField'
import {ErrorSummaries} from '../../factory/createEditableForm'
import {bindQueryParam} from '../../functions/routerHelper'
import {ListHeaderWithLine} from '../../Templates/items/ListHeader'
import {
    dateAfter,
    lengthBetween,
    noSpecialChars,
    required,
    runRules,
    touchFields
} from '../../../../components/form/ValidateForm'
import {CourseSelector} from '../components/CourseSelector'
import {TeacherSelector} from '../components/TeacherSelector'
import {CourseClassStudentList} from './CourseClassStudentForm'
import {CourseClassSubjectChips} from './components/CourseClassSubjectForm'
import {CourseClassTimetables} from './CourseClassTimetableForm'
import {useCourseClassApi} from './useCourseClassApi'
import {CustomToggleField} from "../../../../components/form/fields/ToggleField";
import WorkspaceContext from "../../../Workspace/WorkspaceContext";
import LookupField from "../../../../components/LookupField";
import TooltipApp from "../../../../components/TooltipApp";
import Pure from "../../../../components/Pure";
import useToggle from "react-use/lib/useToggle";
import {FaUserTie} from "react-icons/fa6";
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {renderIfElse} from "../../../Shared";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {FaChalkboardTeacher} from "react-icons/fa";
import dayjs from "dayjs";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {ROOT_URL} from "../../../../envs/_current/config";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {ItemInformation} from "../../../../components/common/ItemInformation";
import {Section} from "../../../../components/form/ModernForm";
import LinkedPages from "../../../Organization/Settings/Profile/LinkedPages";

const Coordinators = ({form, name, value, defaultValue = [], handleChange = NullAsDefault, courseClassId, ...props}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const timetable_teachers = value || defaultValue;
    const {organization} = useContext(WorkspaceContext)

    return (
        <div className="flex flex-col gap-3">
            <div className="flex">
                <LookupField
                    title={t('teacher/supervisor')}
                    createIfNotExists={true}
                    placeholder={t('click to select / create')}
                    apiPath={`/lookup/teacher/get-by-types?owner_type=organization&owner_id=${organization?.id}${courseClassId ? `&not_course_class_id=${courseClassId}` : ''}`}
                    excludeIds={_.map(timetable_teachers, 'teacher_id')}
                    OptionWrapper={({children, ...props}) =>
                        <div className="p-3 flex items-center gap-2 relative lookup-item" {...props}>
                            {children}
                        </div>
                    }
                    renderOption={(o, i) => {
                        return (
                            <div key={i} className="flex items-center flex-1 gap-3">
                                {renderIf(
                                    !isSm,
                                    <Avatar
                                        size={50}
                                        src={o?.user?.avatar || o.avatar}
                                        className="flex flex-center background-200 rounded-lg"
                                        icon={<FaUserTie size={20} style={{color: '#dddddd'}}/>}
                                    />
                                )}
                                <div className="flex flex-col">
                                    <span className="font-bold text-sm text-color-000 leading-snug tracking-wide">
                                        {o?.prefix_title || ""} {o?.fullname}
                                    </span>
                                    <ItemInformation
                                        label="teacher code" className="text-xs tracking-wider"
                                        value={_.get(o, 'teacher_idcode')}
                                    />
                                </div>
                            </div>
                        )
                    }}
                    handleChange={(e) => {
                        let _timetable_teachers = _.cloneDeep(timetable_teachers);

                        const teacher = _.find(_timetable_teachers, {id: e.target.id});
                        if (!teacher) {
                            _timetable_teachers.push({
                                teacher: e.target,
                                teacher_name: e.target.value,
                                teacher_id: e.target.id,
                                id: e.target.id || e.target.value,
                            });
                            handleChange(_timetable_teachers)
                        }
                    }}
                />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">
                {timetable_teachers.map((timetable_teacher, idx) => {
                    const {teacher, teacher_name} = timetable_teacher ?? {}
                    return (
                        <div key={idx} className="p-2 custom-item-render shadow rounded-md relative">
                            {renderIfElse(
                                teacher,
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        size={30}
                                        src={teacher?.user?.avatar || teacher?.avatar}
                                        icon={<FaUserTie size={16} className="text-color-500"/>}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col flex-1">
                                        <Link to={getLinkToDetail(teacher)}
                                              className="font-bold text-color-000 no-underline leading-snug">
                                            {teacher?.prefix_title || ""} {getTitle(teacher)}
                                        </Link>
                                        <ItemInformation label="teacher code" value={_.get(teacher, 'teacher_idcode')} className="text-2xs italic"/>
                                    </div>
                                </div>,
                                <div className="font-bold text-color-000">
                                    {teacher_name}
                                </div>
                            )}
                            <BiTrash
                                onClick={() => {
                                    let _timetable_teachers = _.cloneDeep(timetable_teachers);
                                    showDeleteConfirmDialog({
                                        translate: t,
                                        title: 'delete teacher',
                                        message: 'are you sure you want to delete it teacher',
                                        onOk: () => {
                                            _.remove(_timetable_teachers, {id: timetable_teacher?.id});
                                            handleChange(_timetable_teachers)
                                        },
                                    })
                                }}
                                className="absolute top-5 right-5 contextIcon text-primary-200 hover:text-primary cursor-pointer"
                            />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

const formSchema = {
    title: {
        children: [
            {
                label: 'name of class',
                name: 'title',
                isRequired: true,
                component: createControlledFormField({
                    placeholder: 'name of class',
                }),
            },
        ],
    },
    description: {
        title: 'short description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    rows: 4,
                    placeholder: 'short description',
                    Component: Input.TextArea,
                    className: 'scrollBarThin'
                }),
            },
        ],
    },
    idname: {
        title: 'url',
        children: {
            name: 'idname',
            component: compose(
                withTranslate,
                mapProps(({onChange, value, translate}) => ({
                    onChange,
                    value,
                    name: 'idname',
                    placeholder: translate('please input name!'),
                    type: 'text',
                    trigger: ['focus'],
                    title: ROOT_URL + '/classroom/' + value,
                    placement: 'topLeft',
                    disabled: true,
                })),
                pure
            )(({title, trigger, placement, ...inputProps}) => (
                <TooltipApp title={title} trigger={trigger} placement={placement}>
                    <Space.Compact className="w-full">
                        <Input value="https://.../classroom/" disabled style={{width: 'auto'}}/>
                        <Input {...inputProps} />
                    </Space.Compact>
                </TooltipApp>
            )),
        },
    },
    channel_privacy: {
        title: 'private channel',
        children: {
            name: 'channel_privacy',
            component: compose(
                withTranslate,
                mapProps(({name, value, onChange, translate}) => ({
                    name,
                    value: Number(value) === 2,
                    onChange: (value) => {
                        onChange(createValue(name, Boolean(value) ? 2 : 1))
                    },
                    title: translate('private channel'),
                    description: translate(
                        'by making a channel private, only members will have access to this channel'
                    ),
                }))
            )(CustomToggleField),
        },
    },
    channel_post_permission: {
        title: 'posting permission',
        children: {
            name: 'channel_post_permission',
            component: compose(
                withTranslate,
                mapProps(({name, value, onChange, translate}) => ({
                    name,
                    value: Number(value) === 3,
                    onChange: (value) => {
                        onChange(createValue(name, Boolean(value) ? 3 : 2))
                    },
                    title: translate('posting permission'),
                    description: translate("Allow changing posting permissions on the news channel; On: only administrators are allowed to post, Off: all students are allowed to post"),

                }))
            )(CustomToggleField),
        },
    },
    container: {
        // title: 'belong to course',
        children: [
            {
                name: 'course',
                isRequired: true,
                component: mapProps(({name, value, form, onChange}) => {
                    const {owner_id, owner_type} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        owner_id,
                        owner_type,
                    }
                })(CourseSelector),
            },
        ],
    },
    class_coordinator: {
        title: 'class coordinator',
        children: [
            {
                name: 'class_coordinator',
                component: mapProps(({name, value, form, onChange}) => {
                    const {owner_id, owner_type} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        owner_id,
                        owner_type,
                    }
                })(TeacherSelector),
            },
        ],
    },
    coordinators: {
        // title: 'coordinators',
        children: [
            {
                name: 'coordinators',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: Coordinators,
                    withForm: ({...props}) => ({form: {...props}}),
                    withProps: ({name, value, onChange, ...props}) => ({
                        defaultValue: value,
                        handleChange: (_value) => {
                            onChange(createValue(name, _value))
                        },
                        ...props
                    }),
                    withValues: ({resetKey, id}) => ({
                        resetKey,
                        courseClassId: id,
                    }),
                }),
            },
        ],
    },
    // Sĩ số tối đa của lớp - cùng convention field student_quota của Course (CourseSetForm.js):
    // prefix label lồng trong Input + parser/formatter thêm dấu phẩy hàng nghìn, không bắt buộc
    // (để trống = chưa khai báo hạn mức, card preview chỉ hiện số học viên hiện tại).
    student_quota: {
        children: [
            {
                name: 'student_quota',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange,
                        // Thiếu className w-full (khác CourseSetForm.js cùng convention) khiến
                        // InputNumber co lại vừa đúng bề rộng nội dung - label prefix trông như đè
                        // lên/lẫn vào control vì ô nhập số gần như không còn chỗ hiển thị (bạn báo lỗi
                        // layout này).
                        className: 'w-full',
                        prefix: (
                            <span className="mr-0.5 font-medium text-xs text-color-400 tracking-wide">
                                {`${translate('student quota')}: `}
                            </span>
                        ),
                        placeholder: '0',
                        type: 'number',
                        min: 0,
                        formatter: (value) => `${value}`.replace(new RegExp(/\B(?=(\d{3})+(?!\d))/g), ','),
                        parser: (value) => {
                            const parsed = value.replace(/[^0-9]/g, '')
                            return parsed ? Number(parsed) : undefined
                        },
                    }))
                )(InputNumber),
            },
        ],
    },
    // Sao chép Môn học từ Khóa vào Lớp mới tạo - BẬT SẴN mặc định (lớp mới thường dạy đúng các môn
    // đã khai báo ở Khóa, tắt đi để chọn tay là ngoại lệ) - cùng pattern copy_course_teachers
    // (CourseSetForm.js, nhân bản khóa học): FE chỉ gửi 1 cờ boolean, BE tự replicate liên kết sang
    // record mới (xem CourseClassController::createCourseClass). CHỈ có ở form Tạo - sửa lớp đã có
    // sẵn sinh viên/lịch học thì việc gán lại Môn học nên làm tại tab Môn học của lớp, không lồng
    // vào form Sửa chung này.
    copy_subjects: {
        children: {
            name: 'copy_subjects',
            component: compose(
                withTranslate,
                mapProps(({name, value, onChange, translate}) => ({
                    name,
                    value: value !== false,
                    onChange: (checked) => onChange(createValue(name, Boolean(checked))),
                    title: translate('copy course subjects'),
                    description: translate('copy course subjects description'),
                }))
            )(CustomToggleField),
        },
    },
    started_finished_date: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                name: 'from_date',
                label: 'from date',
                isRequired: true,
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate, form}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: translate('ex: 20/10/2010'),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                            // Đổi from_date có thể làm to_date đang có sẵn hết hợp lệ - touch cả 2
                            // để lỗi hiện ngay, không đợi submit (xem touchFields, ValidateForm.js).
                            touchFields(form, 'from_date', 'to_date')
                        },
                    }))
                )(DatePicker),
            },
            {
                name: 'to_date',
                label: 'to date',
                isRequired: true,
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate, form}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: translate('ex: 20/10/2010'),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                            touchFields(form, 'to_date')
                        },
                    }))
                )(DatePicker),
            },
        ],
    },

    // Link ngoài riêng của lớp này (vd nhóm Zalo lớp) - BỔ SUNG thêm link dùng chung ở cấp khóa
    // (CourseSetForm.js, formSchema.linked_pages). Tái dùng THẲNG component LinkedPages của
    // Organization (Organization/Settings/Profile/LinkedPages.js), cùng convention linked_pages
    // (page/url) - không tự chế UI song song.
    linked_pages: {
        title: 'external links',
        children: [
            {
                name: 'linked_pages',
                component: compose(
                    mapProps(({name, value, onChange}) => ({
                        data: value,
                        classNames: ['flex items-center gap-3'],
                        renderWrapper: ({children}) => (
                            <div className="flex flex-col gap-3">{children}</div>
                        ),
                        onChange: (value) => {
                            onChange(createValue(name, value))
                        },
                    })),
                    pure
                )(LinkedPages),
            },
        ],
    },
}

const CourseInfo = ({item, style, className}) => {
    const t = useTranslate()
    const {time_open, time_close} = item ?? {}

    return (
        <Translate>
            {(t) => (
                <Section title={t('belong to course')}>
                    <div
                        style={style}
                        className={classNames(
                            'p-3 flex items-center gap-3 border border-color-50 background rounded-xl',
                            className
                        )}>
                        <Avatar
                            size={60}
                            icon={<FaChalkboardTeacher size={30} className="text-secondary-400"/>}
                            className="flex flex-center bg-secondary-50 rounded-xl"
                        />
                        <div className="flex flex-col flex-1">
                            <div className="font-bold text-base text-color-000 tracking-wide">
                                {getTitle(item)}
                            </div>
                            {renderIf(
                                _.some([time_open, time_close]),
                                <DoubleValueItem
                                    showIcon={true}
                                    labelFirst="time"
                                    valueFirst={formatDate(time_open, 'DD/MM/YYYY')}
                                    labelSecond={time_close && ' - ' || ''}
                                    valueSecond={time_close && formatDate(time_close, 'DD/MM/YYYY')}
                                    className="text-xs tracking-wider"
                                />
                            )}
                        </div>
                    </div>
                </Section>
            )}
        </Translate>
    )
}

const validateClassTitle = (title, t) => {
    // Bỏ noLeadingTrailingSpaces - xem lý do ở validateTitle trong CourseSetForm.js (validate live
    // theo keystroke nên khoảng trắng cuối chuỗi lúc đang gõ từ mới báo lỗi giả). Trim trước validate
    // + trim lại lúc submit (xem onSubmit) là đủ.
    const trimmed = typeof title === 'string' ? title.trim() : title
    const rules = [required(t), lengthBetween(2, 180, t), noSpecialChars(t)]
    const error = runRules(trimmed, rules)
    return error ? {title: error} : {}
}

export const CreateCourseClassModal = ({
                                           owner_id,
                                           owner_type,
                                           container,
                                           onSubmit = NullAsDefault,
                                       }) => {
    const t = useTranslate()

    const initialValues = useMemo(
        () => ({
            owner_id,
            owner_type,
            title: undefined,
            description: undefined,
            copy_subjects: true,
        }),
        [owner_id, owner_type]
    )

    const validate = (values) => {
        let errors = {}

        const {title, course, to_date, from_date} = values ?? {}

        Object.assign(errors, validateClassTitle(title, t))

        if (!to_date) {
            errors.to_date = t('required field')
        }

        if (!from_date) {
            errors.from_date = t('required field')
        }

        if (!container && !course) {
            errors.course = t('required field')
        }

        if (!container && !from_date) {
            errors.from_date = t('required field')
        }

        if (!container && !to_date) {
            errors.to_date = t('required field')
        }

        // inclusive=true - lớp có thể diễn ra trong đúng 1 ngày (from_date=to_date hợp lệ).
        const toDateError = from_date && dateAfter(from_date, t, {inclusive: true})(to_date)
        if (toDateError) errors.to_date = toDateError

        return errors
    }

    return (
        <Formik
            onSubmit={(values) => {
                const {
                    course,
                    owner_id,
                    owner_type,
                    to_date,
                    from_date,
                    coordinators,
                    ...rest
                } = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            title: rest.title?.trim(),
                            course_id: getId(course),
                            to_date: getDateString(to_date),
                            from_date: getDateString(from_date),
                            coordinators: JSON.stringify(coordinators),
                        },
                        _.isUndefined
                    )
                )
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <React.Fragment>
                <ErrorSummaries/>
                <ActionModalWrapper
                    action={<FormActionGroups submitProps={{label: 'create'}}/>}>
                    {container ? (
                        <CourseInfo item={container}/>
                    ) : (
                        <Pure>
                            <Section title={t('belong to course')}>
                                <FieldsFactory formSchema={[formSchema.container]}/>
                            </Section>
                        </Pure>
                    )}
                    <Section>
                        <FieldsFactory formSchema={[formSchema.title, formSchema.started_finished_date, formSchema.student_quota]}/>
                    </Section>
                    <Pure>
                        <Section
                            icon={RiListCheck2}
                            title={t('class subjects section title')}
                            subtitle={t('class subjects section subtitle')}>
                            <FieldsFactory formSchema={[formSchema.copy_subjects]}/>
                        </Section>
                    </Pure>
                    <Pure>
                        <Section
                            icon={FaUserTie}
                            title={t('coordinators')}>
                            <FieldsFactory formSchema={[formSchema.coordinators]}/>
                        </Section>
                    </Pure>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

export const EditCourseClassModal = ({
                                         item,
                                         owner_id,
                                         owner_type,
                                         container,
                                         onSubmit = NullAsDefault,
                                     }) => {
    const t = useTranslate()
    const location = useLocation()
    const [isToggle, toggle] = useToggle()
    const refreshKey = location?.state?.refreshToken

    const validate = (values) => {
        let errors = {}

        const {title, course, to_date, from_date} = values ?? {}

        Object.assign(errors, validateClassTitle(title, t))

        if (!to_date) {
            errors.to_date = t('required field')
        }

        if (!from_date) {
            errors.from_date = t('required field')
        }

        if (!container && !course) {
            errors.course = t('required field')
        }

        return errors
    }

    const initialValues = useMemo(() => {
        const {to_date, from_date, ...rest} = item ?? {}
        return {
            ...rest,
            owner_id,
            owner_type,
            refreshKey,
            to_date: parseDayjs(to_date),
            from_date: parseDayjs(from_date),
        }
    }, [item, owner_id, owner_type, refreshKey])

    return (
        <Formik
            onSubmit={(values) => {
                const {course, to_date, from_date, coordinators, linked_pages, ...changed} = shallowDiff(values, initialValues)
                const course_id = values?.course ? getId(course) : null
                onSubmit(
                    _.omitBy(
                        {
                            ...changed,
                            title: changed.title?.trim(),
                            course_id,
                            to_date: getDateString(to_date),
                            from_date: getDateString(from_date),
                            coordinators: JSON.stringify(coordinators),
                            linked_pages: linked_pages ? JSON.stringify(linked_pages) : undefined,
                        },
                        _.isUndefined
                    )
                )
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <React.Fragment>
                <ErrorSummaries/>
                <ActionModalWrapper
                    action={<FormActionGroups submitProps={{label: 'save'}}/>}>
                    {!container && (
                        <Pure>
                            <Section title={t('belong to course')}>
                                <FieldsFactory formSchema={[formSchema.container]}/>
                            </Section>
                        </Pure>
                    )}
                    <Section>
                        <FieldsFactory
                            formSchema={[
                                formSchema.title,
                                formSchema.started_finished_date,
                                formSchema.student_quota,
                                formSchema.description,
                            ]}
                        />
                    </Section>
                    {/* Chip-select môn học của lớp (CourseClassSubjectChips) - ĐẶT giữa "thông tin cơ
                        bản" và "người phụ trách", cùng thứ tự với Section "class subjects" bên form
                        Tạo lớp (CreateCourseClassModal, copy_subjects) - bạn yêu cầu move xuống đây
                        thay vì tách hẳn phía trên EditCourseClassModal (xem CourseClassDetail.js). */}
                    <Pure>
                        <Section
                            icon={RiListCheck2}
                            title={t('class subjects section title')}
                            subtitle={t('class subjects section subtitle')}>
                            <CourseClassSubjectChips item={item}/>
                        </Section>
                    </Pure>
                    <Pure>
                        <Section icon={FaUserTie} title={t('coordinators')}>
                            <FieldsFactory formSchema={[formSchema.coordinators]}/>
                        </Section>
                    </Pure>

                    <Pure>
                        <Section title={t('external links')} subtitle={t('class external links description')}>
                            <FieldsFactory formSchema={[formSchema.linked_pages]}/>
                        </Section>
                    </Pure>

                    <Pure>
                        <Section icon={RiSignalTowerFill} title={t('channel')} subtitle={t('Manage administrative parameters related to the news channel')}>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.channel_privacy,
                                    formSchema.channel_post_permission,
                                ]}
                            />
                        </Section>
                    </Pure>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

export const CourseClassList = ({
                                    item,
                                    owner_id,
                                    owner_type,
                                    header = null,
                                    controls = pagerControls,
                                    renderFooter = renderSelf,
                                }) => {
    const t = useTranslate()

    const course_id = getId(item)

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const {
        onCreate = NullAsDefault,
        onUpdate = NullAsDefault,
        onDelete = NullAsDefault,
        ...rest
    } = useCourseClassApi({
        onCreated: onCancel,
        onUpdated: onCancel,
        onDeleted: onCancel,
    })

    const apiInfo = course_getCourseClasses_Api

    const {keyword, component: search_widget} = controls?.search ?? {}

    const refreshKey = useMemo(
        () =>
            [
                apiInfo?.path?.replace(':id', course_id),
                JSON.stringify(keyword),
                rest.refreshKey,
            ].join(','),
        [keyword, course_id, rest.refreshKey]
    )

    const handleAction = (action, params) => {
        const {id} = params ?? {}
        switch (action) {
            case ClassActionTypes.CLASS_CREATE:
            case ClassActionTypes.CLASS_UPDATE:
            case ClassActionTypes.SHOW_STUDENT_LIST_MODAL:
            case ClassActionTypes.SHOW_TIMETABLE_LIST_MODAL:
                setAction({type: action, value: params})
                break
            case ClassActionTypes.CLASS_DELETE:
                if (id) {
                    showDeleteConfirmDialog({
                        translate: t,
                        title: 'delete course class',
                        message: 'are you sure you want to delete this course class',
                        onOk: () => {
                            onDelete({}, {id})
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiListCheck2 size={14} className="text-green-500"/>,
                        label: 'timetables',
                        key: ClassActionTypes.SHOW_TIMETABLE_LIST_MODAL,
                    },
                    {
                        icon: <RiUserSharedLine size={14} className="text-color-400"/>,
                        label: 'students',
                        key: ClassActionTypes.SHOW_STUDENT_LIST_MODAL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: ClassActionTypes.CLASS_UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: ClassActionTypes.CLASS_DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const modal = useMemo(() => {
        let params = {}
        let modal_params = {}
        let Component = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        const id = getId(action?.value)
        switch (action?.type) {
            case ClassActionTypes.CLASS_CREATE:
                Component = CreateCourseClassModal
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('create class')}
                        </div>
                    ),
                }
                params = {
                    container: item,
                    onSubmit: (values) => {
                        onCreate(values, {id: course_id})
                    },
                }
                break
            case ClassActionTypes.CLASS_UPDATE:
                Wrapper = withProps({id})(FetchClassById)
                Component = EditCourseClassModal
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('edit class')}
                        </div>
                    ),
                }
                params = {
                    container: item,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                }
                break
            case ClassActionTypes.SHOW_STUDENT_LIST_MODAL:
                Wrapper = withProps({id})(FetchClassById)
                Component = (props) => bindingSearch(props)(CourseClassStudentList)
                modal_params = {
                    title: (
                        <div className="font-bold text-color-000 tracking-wide 222-222">
                            {t('students of class')}
                        </div>
                    ),
                }
                break
            case ClassActionTypes.SHOW_TIMETABLE_LIST_MODAL:
                Component = CourseClassTimetables
                Wrapper = withProps({id})(FetchClassById)
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('timetables')}
                        </div>
                    ),
                }
                break
            default:
                break
        }
        return (
            <Modal
                width={720}
                footer={null}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Component
                                {...params}
                                {...{item, onCancel, owner_id, owner_type}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, course_id, owner_id, owner_type])

    return (
        <ActionModalWrapper className="flex-1 p-3">
            {header}
            <div className="flex flex-col gap-3 flex-1">
                <ListHeaderWithLine
                    className="text-sm"
                    title="list of classes"
                    extra={
                        <Button
                            size="small"
                            type="primary"
                            className="flex flex-center button-rounded-md no-border font-medium text-xs px-4"
                            onClick={() => {
                                handleAction(ClassActionTypes.CLASS_CREATE)
                            }}>
                            {t('create')}
                        </Button>
                    }
                />
                {search_widget}
                <EntityList
                    key={refreshKey}
                    apiInfo={apiInfo}
                    values={{keyword}}
                    RenderEntity={React.Fragment}
                    query={bindQueryParam({id: course_id})}
                    renderItem={renderCourseClass({translate: t, renderContextMenu})}
                />
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}

